import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Fields, reduxForm } from 'redux-form';
import { Button, Modal, FormLabel } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  TextInput,
  TextArea,
  FormErrorMessages,
  scrollToFirstError,
  generateValidation,
  SharedFormMessages as formMessages,
} from 'ecs-react-components/dist/index.es';
import validations from './EmailForm.validations';
import { messages } from './EmailForm.i18n';
import { messages as pageMessages } from './HealthSummary.i18n';
import { sendHealthSummary } from '../../redux/modules/health-summary/health-summary-middleware';

export const fields = ['recipient', 'sender', 'emailBody'];

class EmailForm extends Component {
  constructor(props) {
    super(props);
    this.title = null;
    this.state = {
      showEmailModal: false,
    }
  }

  UNSAFE_componentWillMount() {
    this.props.change('sender', this.props.initialSenderEmail);
  }

  onSubmit = (formValues) => {
    const {
      dispatch,
      healthSummary,
      patient,
      languageCode,
    } = this.props;

    const postBody = {
      patientId: patient.patientId,
      ifSystemId: healthSummary.currentIdentifier.ifSystemId,
      senderAddress: formValues.sender,
      recipientAddress: formValues.recipient,
      messageText: formValues.emailBody,
      transmitType: 'email',
      formName: 'emailCcdaForm',
    };
    const identifier = healthSummary.currentIdentifier.ccdaId ?
      {
        // MOSAIQ
        identifier: {
          ccdaId: healthSummary.currentIdentifier.ccdaId,
        },
      } :
      {
        // ARIA
        identifier: {
          startDate: healthSummary.currentIdentifier.startDate,
          endDate: healthSummary.currentIdentifier.endDate,
        },
      };
    dispatch(sendHealthSummary({ ...postBody, ...identifier }, languageCode));
    this.closeEmailModal();
  }

  canTriggerButton = (event) => (
    event &&
    (event.type === 'click' ||
    (event.type === 'keypress' &&
      (event.charCode === 13 || event.keyCode === 13)))
  );

  openEmailModal = (event) => {
    if (this.canTriggerButton(event)) {
      this.setState({ showEmailModal: true });
    }
  }

  closeEmailModal = () => {
    this.setState({ showEmailModal: false });
  }

  renderFields = (fieldsMeta) => {
    const { formatMessage } = this.props.intl;
    const getLabel = (f) => f + 'Label';
    const getHint = (f) => f + 'Hint';

    const { recipient, sender, emailBody } = fieldsMeta;

    return (
      <div>
        <div className="form-group">
          <div className="mb-3">
          <FormLabel id={getLabel(recipient.input.name)}
            htmlFor={recipient.input.name}
            data-qa-item="RecipientLabel"
          >
          {formatMessage(messages.recipient.label)}
          </FormLabel>
          <TextInput
            field={recipient}
            placeholder={formatMessage(messages.recipient.placeholder)}
            email={validations.recipient.email}
            qaTag="Recipient"
            ariaLabelledBy={getLabel(recipient.input.name)}
          />
          <FormErrorMessages field={recipient}
            ariaDescribedby={getLabel(recipient.input.name)}
            customMessage={formatMessage(formMessages.error.email)}
          />
          <span id={getHint(recipient.input.name)} className="sr-only">
            {formatMessage(messages.recipient.placeholder)}
          </span>
          </div>
        </div>
        <div className="form-group">
        <div className="mb-3">
          <FormLabel id={getLabel(sender.input.name)}
            htmlFor={sender.input.name}
            data-qa-item="SenderLabel"
          >
            {formatMessage(messages.sender.label)}
          </FormLabel>
          <TextInput
            field={sender}
            placeholder={formatMessage(messages.sender.placeholder)}
            email={validations.sender.email}
            qaTag="Sender"
            ariaLabelledBy={getLabel(sender.input.name)}
          />
            <FormErrorMessages field={sender}
              ariaDescribedby={getLabel(sender.input.name)}
              customMessage={formatMessage(formMessages.error.email)}
            />
          <span id={getHint(sender.input.name)} className="sr-only">
            {formatMessage(messages.sender.placeholder)}
          </span>
        </div>
        </div>
        <div className="form-group">
        <div className="mb-3">
          <FormLabel id={getLabel(emailBody.input.name)}
            htmlFor={emailBody.input.name}
            data-qa-item="MessageBodyLabel"
          >
            {formatMessage(messages.body.label)}
            <FormErrorMessages field={emailBody}
              ariaDescribedby={getLabel(emailBody.input.name)}
            />
          </FormLabel>
          <TextArea
            field={emailBody}
            placeholder={formatMessage(messages.body.placeholder)}
            qaTag="MessageBody"
            ariaLabelledBy={getLabel(emailBody.input.name)}
            rows={3}
            maxLength={validations.emailBody.maxLength}
          />
          <span id={getHint(emailBody.input.name)} className="sr-only">
            {formatMessage(messages.body.placeholder)}
          </span>
        </div>
        </div>
      </div>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { handleSubmit } = this.props;
    return (
      <>
        <a type="button" className="btn btn-outline-secondary me-1 mb-1" tabIndex="0"
          data-qa-item="SendByEmailButton"
          onClick={ this.openEmailModal }
          onKeyPress={ this.openEmailModal }
          aria-describedby="opensPopupLabel" role="button"
        >
          <span className="fa-solid fa-envelope mr-1"></span>
          <FormattedMessage {...pageMessages.page.sendByEmail} />
        </a>
        <Modal
          show={ this.state.showEmailModal }
          onHide={ this.closeEmailModal }
          backdrop="static"
          aria-labelledby="modalTitle"
        >
          <Modal.Header closeButton>
            <Modal.Title className="fs-5" data-qa-item="modal-title" as="h4">
              <div tabIndex="0" id="modalTitle">
                {formatMessage(messages.page.header)}
              </div>
            </Modal.Title>
          </Modal.Header>
          <form onSubmit={handleSubmit(this.onSubmit)}>
            <Modal.Body>
              <p data-qa-item="PrimaryExplanation" aria-describedby="primaryTop" tabIndex="0">
                <span id="primaryTop">{formatMessage(messages.explanation.primary)}</span>
              </p>
              <Fields names={fields} component={this.renderFields} />
              <p data-qa-item="SecondaryExplanation" aria-describedby="secondary" tabIndex="0">
                <span id="secondary">{formatMessage(messages.explanation.secondary)}</span>
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button type="submit"
                data-qa-item="SubmitButton"
              >
                <FormattedMessage {...messages.send.label} />
              </Button>
              <Button type="button" variant="outline-secondary"
                onClick={ this.closeEmailModal }
                data-qa-item="CancelButton"
              >
                <FormattedMessage {...messages.cancel.label} />
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </>
    );
  }
}

EmailForm.propTypes = {
  intl: PropTypes.object,
  patient: PropTypes.object,
  dispatch: PropTypes.func,
  handleSubmit: PropTypes.func,
  healthSummary: PropTypes.object,
  change: PropTypes.func,
  initialSenderEmail: PropTypes.string,
  languageCode: PropTypes.string,
};

const formConfig = {
  form: 'emailCcdaForm',
  onSubmitFail: (errors) => scrollToFirstError(errors, fields),
  fields,
  ...generateValidation(validations),
};

const mapStateToProps = (state) => ({
  patient: state.profile.patient,
  healthSummary: state.healthSummary,
  initialSenderEmail: state.profile.patient.emailAddress,
  languageCode: state.language.languageCode,
});

export default reduxForm(formConfig)(connect(mapStateToProps)(injectIntl(EmailForm)));
